import React from 'react';
import {HomepageSection, HomepageSectionHeader} from '../Homepage';
import ReactHighcharts from 'react-highcharts';
import PropTypes from 'prop-types';
import filter from 'App/util/common/filter';
import {process_country} from "../helper";


class LivingStatus extends React.Component {
  render() {
    const options = {
      rename: {
        map: {
          'ALIVE': 'alive',
          'DEAD': 'dead',
          'LOST': 'lost to follow up',
          'DISCHARGED': 'discharged after complete recovery'
        }
      }
    };
    const extData = process_country("living_status");
    const living_status = filter(this.props.data, 'living_status', options);

    const configLivingStatus = {
      chart: {
        type: 'column'
      },
      exporting: { enabled: false },
      title: {
        text: 'Patients according to their living status'
      },
      xAxis: {
        type: 'category'
      },
      yAxis: {
        min: 0,
        title: {
          text: 'number of patients'
        }
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            borderRadius: 2,
            y: -10,
            shape: 'callout'
          }
        }
      },
      tooltip: false,

      series: [
        {
          'name': 'Patients',
          'colorByPoint': true,
          'data':
            living_status.map(elem => ({
              name: elem.living_status,
              y: elem.count + extData[elem.living_status]
            }))
        }
      ]
    };

    return (
      <HomepageSection>
        <HomepageSectionHeader>
          <h2><span>{'Living Status '}</span>
          </h2>
        </HomepageSectionHeader>
        <div className='text-center' style={{marginTop: 25, marginBottom: 25}}>
          <ReactHighcharts config={configLivingStatus}/>
        </div>
      </HomepageSection>
    );
  }
}

LivingStatus.propTypes = {
  data: PropTypes.array.isRequired
};

export default LivingStatus;


// WEBPACK FOOTER //
// ./src/views/Pages/Homepage/Sections/LivingStatus.js